import { API_URL } from '../config/apiConfig';

export const getPlans = async (affiliateId) => {
        try {

            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error fetching plans:", error);
            return [];
        }
    };

    export const createPlan = async (planData) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json" },
                body: JSON.stringify(planData),
            });
            return await response.json();
        } catch (error) {
            console.error("Error creating plan:", error);
        }
    };

    export const updatePlan = async (planId, planData) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans/${planId}`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json" },
                body: JSON.stringify(planData),
            });
            return await response.json();
        } catch (error) {
            console.error("Error updating plan:", error);
        }
    };

    export const deletePlan = async (planId) => {
        try {
            const token = localStorage.getItem("token");
            await fetch(`${API_URL}/plans/${planId}`, { method: "DELETE",
                headers: {
                "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json" },


            });
        } catch (error) {
            console.error("Error deleting plan:", error);
        }
    };

    export const handleBuyPlan = async (planData, currentAffiliateId, currentAppliedCredit, contract, currentMerchantReference, currentIsContractPayment, isFamilyMember, familyMemberId, isPlanStartDate, planStartDate, discountAmount = 0, discountCodeId = null) => {
        try {

            const data = { planData, currentAppliedCredit, contract, currentMerchantReference, currentIsContractPayment, isFamilyMember, familyMemberId, isPlanStartDate, planStartDate, discountAmount, discountCodeId };
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans/buy-plan/${currentAffiliateId}`, {
                method: "POST",
                headers: { "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });
            return await response.json();

        } catch (error) {
            console.error("Error buying plan:", error);

        }
    }

    export const getUserCredit = async ( affiliateId) => {
        try {

            const token = localStorage.getItem("token");
            // Näiteks fetch() või axios() abil andmed edastada
            const response = await fetch(`${API_URL}/plans/credit/${affiliateId}`, {
                method: "GET",
                headers: { "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json" },

            });

            if (!response.ok) {
                throw new Error('Failed to fetch credit');
            }
            const data = await response.json();
    return data
        } catch (error) {
            console.error(error);
            // kuva error kasutajale
        }
    }

    export const updateUserPlan = async (planId, planData) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans/user/${planId}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(planData),
            });
            return await response.json();
        } catch (error) {
            console.error("Error updating plan:", error);
            return null;
        }
    };

    /**
     * Määrab kasutajale (UserPlan tabelisse) valitud plaani.
     * planId: number, userId: number
     */
    export const assignPlanToUser = async (planId, userId, affiliateId, familyMemberId, isPlanStartDate, planStartDate) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans/assign`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ planId, userId, affiliateId, familyMemberId, isPlanStartDate, planStartDate }),
            });
            return await response.json();
        } catch (error) {
            console.error("Error assigning plan to user:", error);
            return null;
        }
    };

    // In planApi.js or similar file
    // Frontend sends final amount (base - credit - discount); backend uses it as-is
    export const createMontonioPayment = async (
        planData,
        affiliateId,
        appliedCredit,
        contract,
        returnUrl,
        userData,
        isFamilyMember,
        familyMemberId,
        isPlanStartDate,
        planStartDate,
        discountAmount = 0,
        discountCodeId = null,
        paymentMethod = "paymentInitiation"
    ) => {
        let paymentAmount = planData.price;
        if (contract && contract.isFirstPayment && contract.firstPaymentAmount) {
            paymentAmount = contract.firstPaymentAmount;
        }
        // Round to 2 decimals to avoid floating point issues (e.g. 3 - 2.7 - 0.3 = 4.44e-17)
        const finalAmount = parseFloat(Math.max(paymentAmount - appliedCredit - (discountAmount || 0), 0).toFixed(2));
        if (finalAmount === 0) {
            return { is_fully_credited: true };
        }

        const token = localStorage.getItem("token");
        let description = planData.paymentDescription
            ? `Irontrack - ${planData.name} - ${planData.paymentDescription}`
            : `Irontrack - ${planData.name}`;
        if (contract && contract.isFirstPayment && contract.firstPaymentAmount) {
            description = `Irontrack - ${planData.name} - First payment `;
        }

        try {
            const response = await fetch(`${API_URL}/payments/montonio`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    amount: finalAmount.toFixed(2),
                    orderId: planData.id || Date.now(),
                    description: description,
                    userData: userData,
                    affiliateId,
                    appliedCredit,
                    contractId: contract?.id,
                    planData,
                    isFamilyMember,
                    familyMemberId,
                    sessionToken: token,
                    isPlanStartDate,
                    planStartDate,
                    discountCodeId: discountCodeId || null,
                    paymentMethod
                }),
            });

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.message || 'Payment creation failed');
            }

            return {
                payment_url: data.paymentUrl,
                order_uuid: data.orderUuid
            };
        } catch (error) {
            console.error('Error creating payment:', error);
            throw error;
        }
    };
    export const checkPaymentStatus = async (orderToken, merchantReference = null) => {
        try {
            const query = orderToken
                ? `token=${encodeURIComponent(orderToken)}`
                : `merchantReference=${encodeURIComponent(merchantReference || '')}`;
            const response = await fetch(`${API_URL}/payments/montonio/status?${query}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                }
            });

            return await response.json();
        } catch (error) {
            console.error('Error checking payment status:', error);
            throw error;
        }
    };

    export const searchUsers = async (query) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans/search-users?query=${encodeURIComponent(query)}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error searching users:", error);
            return [];
        }
    };

    export const getAssignedUsers = async (planId) => {
        try {
            const response = await fetch(`/api/plans/${planId}/assigned-users`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching assigned users:', error);
            throw error;
        }
    };

    export const deleteUserPlan = async (userPlanId) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/plans/user/${userPlanId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error('Failed to delete user plan');
            }

            return true;
        } catch (error) {
            console.error("Error deleting user plan:", error);
            return false;
        }
    }